videojs.addLanguage('en', {
  "Share settings": "Share",
  "Share button": "Share",
  "Share link": "Video link",
  "Share link copy": "copy",
  "Share generate": "generate code",
  "Share copy code": "copy code",
  "Share other size": "Other size",
  "Share error": "Error. Check data and try again.",
  "Share copied": "copied"
});